import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { MenuState } from '../../../store/reducers/menuReducer';
import { RootState } from '../../../store/index';

import './Index.css'
import LcIconLink from '../../Generic/LcIconLink';

interface Props {
    toggle: boolean;
}

const SubMenu: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch({ type: 'MENU_USER_VISIBLE', payload: false });
    }, [])

    const handleClickSubMenu = (id: string) => {
        if (window.innerWidth <= 600) {
            dispatch({ type: 'MENU_TOGGLE', payload: true });
        }

        var submenu = menu.selectedItem.children.find((c: { id: string; }) => c.id === id);

        // dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: submenu });

        if (submenu.children.length > 0) {
            let first = submenu.children[0];
            history.push("/" + first.route)
        }

        dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
    }

    //Largura dinâmica para criar a segunda coluna
    const handleRef = (node: any) => {
        if (node && node.scrollWidth) {
            node.style.width = 0;
            node.style.width = node.scrollWidth + 'px';
        }
    }

    //Carrega dados de "ExtraData" dos itens do menu
    const getLC11data = (item: any, data: string) => {
        if (item.extraData) {
            try {
                let ed = JSON.parse(item.extraData);
                return ed[data] || false;
            }
            catch (error) {
                return false
            }
        }
        return false;
    }

    return (
        menu && menu.selectedItem &&
        <div className={`submenu ${props.toggle && 'toggle'}`}>

            <div className="closemenu mobile-only">
                <LcIconLink icon="ppi ppi-x" tooltip="Fechar" onClick={() => { dispatch({ type: 'MENU_SUB_VISIBLE', payload: false }) }}></LcIconLink>
            </div>
            <div className="title">
                {getLC11data(menu.selectedItem, 'lc11Titulo') || (menu.selectedItem.name)}
            </div>

            <div className="items" ref={handleRef}>
                {
                    menu.selectedItem.children.map((item: any) => {
                        return (item.children.length > 0)
                            ? <div key={item.id} className="item" onClick={() => handleClickSubMenu(item.id)}>
                                <div className="title">
                                    {item.name}
                                    <div className="subtitle">{getLC11data(item, 'info') || item.name}</div>
                                </div>
                            </div>
                            : <Link key={item.id} className="item" to={`/${item.route}`} onClick={() => handleClickSubMenu(item.id)}>
                                <div className="title">
                                    {item.name}
                                    <div className="subtitle">{getLC11data(item, 'info') || item.name}</div>
                                </div>
                            </Link>
                    })
                }
            </div>
        </div>
    );
}

export default SubMenu;